module.exports = __webpack_public_path__ + "static/media/pla_sit_spe_met.e349b454.png";